export function PageHeader({ title, subtitle, icon: Icon, actions }) {
  return (
    <div className="flex items-start justify-between gap-4 flex-wrap mb-6 fade-up">
      <div className="flex items-center gap-3">
        {Icon && (
          <div className="w-11 h-11 rounded-xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center">
            <Icon className="w-5 h-5 text-amber-400" />
          </div>
        )}
        <div>
          <h1 className="font-head text-2xl font-bold tracking-tight text-gray-100">{title}</h1>
          {subtitle && <p className="text-sm text-gray-400 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {actions}
    </div>
  );
}

const STATUS_META = {
  non_inviata: { label: "Non inviata", cls: "bg-white/5 text-gray-400 border-white/10" },
  inviata: { label: "Inviata", cls: "bg-sky-500/15 text-sky-400 border-sky-500/30" },
  risposta: { label: "Risposta", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  sent: { label: "Inviata", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  simulated: { label: "Simulata", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  failed: { label: "Fallita", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
};

export function StatusBadge({ status }) {
  const m = STATUS_META[status] || STATUS_META.non_inviata;
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium border ${m.cls}`}>
      {m.label}
    </span>
  );
}

export function Stars({ count }) {
  return (
    <span className="text-amber-400 text-xs tracking-tight" title={`${count} stelle`}>
      {"★".repeat(count)}<span className="text-gray-700">{"★".repeat(Math.max(0, 5 - count))}</span>
    </span>
  );
}

export function Spinner({ className = "" }) {
  return (
    <div className={`inline-block w-4 h-4 border-2 border-amber-500/30 border-t-amber-500 rounded-full spin-slow ${className}`} />
  );
}

export function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      {Icon && <Icon className="w-10 h-10 text-gray-600 mb-3" />}
      <div className="text-gray-300 font-medium">{title}</div>
      {hint && <div className="text-sm text-gray-500 mt-1 max-w-sm">{hint}</div>}
    </div>
  );
}
